var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Link, Anchor, NavLink } from "./..";
import { themeLss } from "../../lss";
import styled from "../../styled";
import { isUrlAbsolute, noop } from "../../utils";
import { buttonCss } from './Button';
export var ButtonLink = styled(function (_a) {
    var to = _a.to, disabled = _a.disabled, props = __rest(_a, ["to", "disabled"]);
    return (typeof to === 'object' || !isUrlAbsolute(to)) && !disabled ? (React.createElement(Link, __assign({}, props, { to: to }))) : (React.createElement(Anchor, __assign({}, props, { disabled: disabled, href: !disabled ? to : undefined, onClick: !disabled ? props.onClick : noop })));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), buttonCss, themeLss());
export var ButtonNavLink = styled(function (_a) {
    var to = _a.to, disabled = _a.disabled, props = __rest(_a, ["to", "disabled"]);
    return (typeof to === 'object' || !isUrlAbsolute(to)) && !disabled ? (React.createElement(NavLink, __assign({}, props, { to: to }))) : (React.createElement(Anchor, __assign({}, props, { disabled: disabled, href: !disabled ? to : undefined, onClick: !disabled ? props.onClick : noop })));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  text-decoration: ", ";\n  ", "\n"], ["\n  ", "\n  text-decoration: ", ";\n  ", "\n"])), buttonCss, function (_a) {
    var isActive = _a.isActive;
    return (isActive ? 'underline' : 'inherit');
}, themeLss());
var templateObject_1, templateObject_2;
//# sourceMappingURL=ButtonLink.js.map